export function normalizeServerEntitlement(status) {
  if (!status || status.isPro !== true) {
    return {
      isPro: false,
      expiryDate: null,
      daysRemaining: 0,
      lifetime: false,
    };
  }

  if (status.lifetime === true) {
    return {
      isPro: true,
      expiryDate: null,
      daysRemaining: null,
      lifetime: true,
    };
  }

  if (!status.proExpiryDate) {
    return {
      isPro: false,
      expiryDate: null,
      daysRemaining: 0,
      lifetime: false,
    };
  }

  const expiryDate = new Date(status.proExpiryDate);
  const active =
    Number.isFinite(expiryDate.getTime()) && expiryDate.getTime() > Date.now();

  return {
    isPro: active,
    expiryDate: active ? expiryDate : null,
    daysRemaining: active ? Math.max(0, status.daysRemaining || 0) : 0,
    lifetime: false,
  };
}

export function localStorageCannotGrantPro() {
  return false;
}
